module.exports = __webpack_public_path__ + "img/dialogImg.a77a372e.png";